import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-como-trabajamos',
  templateUrl: './como-trabajamos.component.html',
  styleUrls: ['./como-trabajamos.component.css']
})
export class ComoTrabajamosComponent implements OnInit {

  // Timeline del flujo de servicio
  flujoServicio = [
    {
      paso: 1,
      titulo: 'Diagnóstico',
      descripcion: 'Evaluamos necesidades, barreras y contexto de tu empresa',
      entregable: 'Informe de diagnóstico con recomendaciones',
      responsable: 'Equipo de consultores',
      duracion: '1-2 semanas',
      icono: 'fas fa-search'
    },
    {
      paso: 2,
      titulo: 'Búsqueda',
      descripcion: 'Mapeamos talento en nuestra base y aliados estratégicos',
      entregable: 'Lista de candidatos pre-evaluados',
      responsable: 'Equipo de talento',
      duracion: '2-4 semanas',
      icono: 'fas fa-users'
    },
    {
      paso: 3,
      titulo: 'Formación/Adaptación',
      descripcion: 'Desarrollamos competencias y adaptamos puestos',
      entregable: 'Plan de formación y adaptaciones',
      responsable: 'Equipo de formación + consultores',
      duracion: '4-12 semanas',
      icono: 'fas fa-graduation-cap'
    },
    {
      paso: 4,
      titulo: 'Vinculación y Ajustes',
      descripcion: 'Acompañamos la contratación e implementamos ajustes',
      entregable: 'Contrato firmado + ajustes implementados',
      responsable: 'Equipo de vinculación',
      duracion: '1-2 semanas',
      icono: 'fas fa-handshake'
    },
    {
      paso: 5,
      titulo: 'Seguimiento',
      descripcion: 'Medimos impacto y acompañamos la adaptación',
      entregable: 'Reporte de métricas y seguimiento',
      responsable: 'Equipo de seguimiento',
      duracion: '3-6 meses',
      icono: 'fas fa-chart-line'
    },
    {
      paso: 6,
      titulo: 'Retención',
      descripcion: 'Programas de desarrollo y liderazgo inclusivo',
      entregable: 'Plan de retención y desarrollo',
      responsable: 'Equipo de desarrollo',
      duracion: 'Continuo',
      icono: 'fas fa-heart'
    }
  ];

  // RACI simplificado
  raci = [
    {
      fase: 'Diagnóstico',
      responsable: 'Consultor Senior',
      aprobador: 'Director de Proyecto',
      consultado: 'RRHH, Líderes',
      informado: 'Stakeholders'
    },
    {
      fase: 'Búsqueda',
      responsable: 'Especialista de Talento',
      aprobador: 'Consultor Senior',
      consultado: 'RRHH',
      informado: 'Líderes'
    },
    {
      fase: 'Formación',
      responsable: 'Equipo de Formación',
      aprobador: 'Consultor Senior',
      consultado: 'Líderes técnicos',
      informado: 'RRHH'
    },
    {
      fase: 'Vinculación',
      responsable: 'Especialista de Vinculación',
      aprobador: 'RRHH',
      consultado: 'Líderes',
      informado: 'Equipo'
    },
    {
      fase: 'Seguimiento',
      responsable: 'Consultor de Seguimiento',
      aprobador: 'Director de Proyecto',
      consultado: 'Líderes, RRHH',
      informado: 'Stakeholders'
    }
  ];

  // Métricas de control
  metricasControl = [
    {
      categoria: 'SLA Cobertura',
      valor: '95%',
      descripcion: 'Cumplimiento de tiempos prometidos',
      icono: 'fas fa-clock',
      color: 'success'
    },
    {
      categoria: 'Productividad por Puesto',
      valor: '+18%',
      descripcion: 'Mejora promedio en productividad',
      icono: 'fas fa-chart-line',
      color: 'primary'
    },
    {
      categoria: 'eNPS',
      valor: '9.2/10',
      descripcion: 'Satisfacción de líderes y candidatos',
      icono: 'fas fa-star',
      color: 'warning'
    },
    {
      categoria: 'Permanencia 6m',
      valor: '94%',
      descripcion: 'Retención a 6 meses',
      icono: 'fas fa-users',
      color: 'info'
    },
    {
      categoria: 'Permanencia 12m',
      valor: '89%',
      descripcion: 'Retención a 12 meses',
      icono: 'fas fa-user',
      color: 'success'
    }
  ];

  // Muestra de entregables
  entregables = [
    {
      titulo: 'Informe de Barreras',
      descripcion: 'Análisis detallado de barreras físicas, tecnológicas y metodológicas',
      formato: 'PDF + Excel',
      preview: 'Muestra de análisis de 3 puestos críticos',
      icono: 'fas fa-file-alt',
      descarga: '#'
    },
    {
      titulo: 'Plan de Ajustes Razonables',
      descripcion: 'Documento técnico con especificaciones de adaptaciones',
      formato: 'Word + Anexos',
      preview: 'Ejemplo de adaptación para desarrollador con discapacidad visual',
      icono: 'fas fa-tools',
      descarga: '#'
    },
    {
      titulo: 'Reportes de Cumplimiento',
      descripcion: 'Documentación para auditorías y certificaciones',
      formato: 'PDF + Word',
      preview: 'Vista previa del reporte',
      icono: 'fas fa-clipboard',
      descarga: '#'
    },
    {
      titulo: 'Métricas de Impacto',
      descripcion: 'Reportes detallados de productividad y retención',
      icono: 'fas fa-chart-line',
      color: 'info'
    },
    {
      titulo: 'Perfil del Candidato',
      descripcion: 'Evaluación completa de competencias y adaptaciones',
      formato: 'PDF + Excel',
      preview: 'Perfil detallado del candidato',
      icono: 'fas fa-user',
      descarga: '#'
    }
  ];

  // Metodología
  metodologia = {
    enfoque: 'Human-centered design con enfoque en diversidad',
    principios: [
      'Inclusión desde el diseño',
      'Acompañamiento continuo',
      'Métricas de impacto',
      'Mejora continua'
    ],
    herramientas: [
      'Design Thinking',
      'Lean Six Sigma',
      'Agile/Scrum',
      'Human Factors Engineering'
    ]
  };

  // Tiempos de entrega
  tiempos = {
    servicioExpress: '4-6 semanas',
    servicioEstandar: '3-6 meses',
    transformacionCultural: '6-12 meses',
    seguimiento: 'Continuo'
  };

  // Casos de éxito
  casosExito = [
    {
      empresa: 'TechCorp Colombia',
      sector: 'Tecnología',
      empleados: 150,
      tiempo: '4 meses',
      resultado: '100% cumplimiento + 25% mejora en productividad'
    },
    {
      empresa: 'Grupo Empresarial',
      sector: 'Servicios',
      empleados: 300,
      tiempo: '8 meses',
      resultado: 'Transformación cultural completa + 40% mejora en eNPS'
    }
  ];

  // Garantías
  garantias = [
    {
      titulo: 'Cumplimiento Legal',
      descripcion: 'Garantizamos el cumplimiento de la Ley 2466',
      icono: 'fas fa-shield',
      color: 'success'
    },
    {
      titulo: 'Satisfacción Garantizada',
      descripcion: 'Si no estás satisfecho, ajustamos sin costo adicional',
      icono: 'fas fa-heart',
      color: 'danger'
    },
    {
      titulo: 'Resultados Medibles',
      descripcion: 'Compromiso con métricas específicas de impacto',
      icono: 'fas fa-chart-bar',
      color: 'primary'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  // Métodos para funcionalidad
  descargarEntregable(entregable: any): void {
    console.log('Redirigiendo a contacto para descargar:', entregable.titulo);
    this.router.navigate(['/contacto']);
  }

  verDetallePaso(paso: any): void {
    console.log('Ver detalle del paso:', paso.titulo);
    // Aquí se podría abrir un modal o navegar a una página de detalle
  }

  contactarConsultor(): void {
    console.log('Redirigiendo a contacto');
    this.router.navigate(['/contacto']);
  }
}
